/**
 * PGS-3499: config values only, no SDK imports here, so this stays trivially
 * importable from the ApolloLink (otelLink.ts) without dragging in the
 * tracer provider bootstrap (otelBrowser.ts).
 *
 * The traces endpoint is unset (tracing disabled) unless explicitly
 * configured. No deployed environment has a browser-facing OTLP endpoint
 * decided yet, so leaving it unset there is deliberate, not an oversight —
 * see the sibling ticket PGS-3060/PGS-3063/PGS-3064 for gatorade-storefront's
 * equivalent decision.
 */
export const getOtelConfig = () => ({
  tracesEndpoint:
    process.env.NEXT_PUBLIC_OTEL_EXPORTER_OTLP_TRACES_ENDPOINT || "",
  sampleRatio: parseFloat(
    process.env.NEXT_PUBLIC_OTEL_TRACE_SAMPLE_RATIO || "1"
  ),
});
